module.exports = __webpack_public_path__ + "img/bestversionofyou.0befa8c3.png";